import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiVercel,
  SiLinux,
  SiDocker
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiWindows />
        <div className="name"><h3>Windows</h3></div>
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <SiLinux />
        <div className="name"><h3>Linux</h3></div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
        <div className="name"><h3>Visual Studio</h3></div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
        <div className="name"><h3>Postman</h3></div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
        <div className="name"><h3>Vercel</h3></div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDocker />
        <div className="name"><h3>Docker</h3></div>
      </Col>
    </Row>
  );
}

export default Toolstack;
